<template>
  <div class="lang-switcher">
    <div class="dropdown is-active">
      <div class="dropdown-trigger">
        <button class="button is-small" @click="toggleDropdown">
          <img :src="currentLang.icon" class="flag-icon" />
          <span class="icon is-small">
            <i class="fas fa-angle-down" />
          </span>
        </button>
      </div>
      <div class="dropdown-menu" v-if="dropdownVisible">
        <div class="dropdown-content">
          <a
            v-for="lang in languages"
            :key="lang.code"
            class="dropdown-item"
            @click="switchLanguage(lang.code)"
          >
            <img :src="lang.icon" class="flag-icon" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import seIcon from '@/assets/icons/se.svg';
import enIcon from '@/assets/icons/en.svg';
import fiIcon from '@/assets/icons/fi.svg';

export default {
  data() {
    return {
      dropdownVisible: false,
      languages: [
        { code: 'sv', icon: seIcon },
        { code: 'en', icon: enIcon },
        { code: 'fi', icon: fiIcon }   
      ]
    };
  },
  computed: {
    ...mapGetters('user', ['getUser']), 

    currentLang() {
      const langCode = this.$i18n.locale || 'sv';
      return this.languages.find(lang => lang.code === langCode) || this.languages[0];
    }
  },
  methods: {
    ...mapActions('user', ['setUser']),

    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },

    async switchLanguage(lang) {
      if (lang === this.$i18n.locale) {
        this.dropdownVisible = false;
        return;
      }

      localStorage.setItem('lang', lang);

      const user = this.getUser;

      if (user?.id) {
        try {
          await this.$services.user.update(user.id, {
            email: user.email,
            userName: user.userName || user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phoneNumber,
            companyId: user.companyId,
            customerId: user.customerId,
            identityId: user.identityId,
            roleIds: user.roleIds ?? [],
            PreferredLanguageCode: lang
          });

          const refreshedUserResponse = await this.$services.user.get(user.id);
          const refreshedUser =
            refreshedUserResponse?.data?.data ??
            refreshedUserResponse?.data ??
            refreshedUserResponse;

          if (refreshedUser) {
            await this.setUser(refreshedUser);
          }
        } catch (error) {
          console.error('Failed to update preferred language', error);
        }

      }

      this.$i18n.locale = lang;

      const pathWithoutLang = this.$route.fullPath.replace(/^\/(en|sv|fi)/, '');
      this.$router.push(`/${lang}${pathWithoutLang}`);

      this.dropdownVisible = false;
    }
  }
};
</script>

<style scoped>
.lang-switcher {
  position: relative;
}

.lang-switcher .dropdown {
  position: relative;
}

.flag-icon {
  width: 24px;
  height: 16px;
  display: block;
  margin: auto;
}

.lang-switcher .dropdown-menu {
  min-width: 40px;
  max-width: 40px;
  left: 0;
  text-align: center;
  padding: 0;
  z-index: 20;
}

.dropdown-item {
  padding: 4px;
}
</style>
